import { Outlet, useLocation, useNavigate } from 'react-router';
import { GlobalStyles } from 'themes';

import Header from 'components/Layout/Header';
import Loader from 'components/Loader';
import useProgressProvider from 'providers/ProgressProvider';
import useSessionProvider from 'providers/SessionProvider';
import useSurveyProvider from 'providers/SurveyProvider';
import useThemeProvider from 'providers/ThemeProvider';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useFetch from 'use-http';

export default function Home() {
    const { SetUp, initiate, setInitiate, logoPath, status, setStatus, setChannel, setTimeremaining } =
        useSessionProvider();
    const { Theme, setTheme } = useThemeProvider();
    const { setConvo, setRemainingTime, setTimeflag } = useSurveyProvider();
    const history = useNavigate();
    const location = useLocation();
    const { setProgress, setShowProgress, setTotal, setDone } = useProgressProvider();
    const { post, loading } = useFetch();
    const { i18n } = useTranslation();
    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const pathname = location.pathname;
        const session_id = query.get('session_id');

        if (session_id && /^\d+$/.test(session_id)) {
            if (!initiate) {
                setInitiate(true);
                post('/Session/InitiateSession', { session_id, source: 'Web', messenger_conversation_id: '' })
                    .then((res) => {
                        if (res && res.session) {
                            SetUp(session_id, res);
                            var survey = res?.survey;
                            setTimeflag(survey?.timeRemaining);
                            setShowProgress(survey?.useProgress);

                            if (pathname.includes('/unsubscribe')) {
                                setStatus('Unsubscribed');
                                const channel = query.get('channel');
                                setChannel(channel);
                                history({
                                    pathname: '/unsubscribe',
                                    search: `?campaign=${res?.survey?.name}&session_id=${session_id}&channel=${channel}`
                                });
                                return;
                            } else if (res?.status === 'New') {
                                try {
                                    if (survey?.staticSurvey) {
                                        setConvo(res?.chat);
                                    } else {
                                        setConvo((prev) => {
                                            return [...prev, res?.current_question];
                                        });
                                    }
                                    if (survey?.timeRemaining) {
                                        setRemainingTime(res?.remaining_time);
                                    }
                                    setProgress(0);
                                    setTotal(res?.total_questions);
                                } catch (ex) {
                                    console.trace(ex);
                                }
                            } else if (res?.status === 'Resume') {
                                try {
                                    setConvo(res?.chat);
                                    if (!survey?.staticSurvey && res && res.chat && res.chat?.length > 0) {
                                        setProgress(res?.progress);
                                        setTotal(res?.total_questions);
                                        setDone(res?.question_completed);
                                    } else if (survey?.staticSurvey && res && res.queue && res.queue?.length > 0) {
                                        setProgress(res?.progress);
                                        setTotal(res?.total_questions);
                                        setDone(res?.question_completed);
                                    }

                                    if (survey?.timeRemaining) {
                                        setRemainingTime(res?.remaining_time);
                                    }
                                } catch (ex) {
                                    console.trace(ex);
                                }
                            } else if (res?.status === 'Unsubscribed') {
                                setStatus('Unsubscribed');
                                const channel = query.get('channel');
                                setChannel(channel);
                                history({
                                    pathname: '/unsubscribe',
                                    search: `?campaign=${res?.survey?.name}&session_id=${session_id}&channel=${channel}`
                                });
                                return;
                            } else if (res?.status === 'Completed') {
                                setStatus('Completed');
                            } else if (res?.status.includes('Expired')) {
                                setStatus('Expired');
                            } else if (res?.status === 'InValid') {
                                setStatus('InValid');
                            } else {
                                setStatus('InValid');
                            }
                            history({
                                pathname: '/survey',
                                search: `?campaign=${res?.survey?.name}&session_id=${session_id}`
                            });
                        } else {
                            setStatus('InValid');
                        }
                    })
                    .catch((err) => {
                        console.log({ err });
                        setStatus('InValid');
                        history({ pathname: '/survey', search: `?session_id=${session_id}` });
                    });
            } else {
            }
        } else {
            if (pathname.includes('preview') || pathname.includes('generate')) {
            } else {
                setStatus('InValid');
                if (session_id === null) {
                 //     window.location.href = process.env.REACT_APP_INSIGHTS;
                } else {
                    history({ pathname: '/survey', search: `?session_id=${session_id}` });
                }
            }
        }
    }, [
        location.search,
        location.pathname,
        history,
        setTheme,
        initiate,
        setConvo,
        post,
        setProgress,
        setStatus,
        i18n,
        setTotal,
        setChannel
    ]);

    return (
        <>
            <GlobalStyles theme={Theme} />
            {!loading && status !== 'InValid' && <Header {...{ logo: logoPath }} />}
            {loading && <Loader />}
            <Outlet />
        </>
    );
}
